import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    flex: '1',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '0.5rem',
    backgroundColor: '#F5F8FA'
  },

  tasks: {
    '& > div': {
      marginBottom: ({ smallMedia }) => (!smallMedia ? '2rem' : '0'),

      '&:last-child': {
        marginBottom: ({ smallMedia }) => (smallMedia ? '0' : '0.5rem')
      }
    },

    '& .table-root': {
      borderRadius: '0 !important',
      boxShadow: 'none !important'
    },

    '& .tbody': {
      maxHeight: 'unset !important',

      '& .table-row': {
        height: '36px !important'
      }
    }
  }
}))

export default useStyles
